<template>
	<el-dialog :title="title" :close-on-click-modal="false" :visible.sync="subVisible" width="922px" ref="dialog">
		<el-row>
			<div class="tiv">描述</div>
		</el-row>
		<el-row style="margin-top:10px;margin-bottom:10px">
			<el-input type="textarea" rows="9" v-model="dataForm.descContent" placeholder="请填写"></el-input>
		</el-row>
		<el-row>
			<div class="tiv">
				照片上传
			</div>
		</el-row>
		<el-row style="margin-left:114px;margin-top:10px">
			<el-col :span="24">
				<el-upload ref="uploadSituation" class="upload-demo" action="action" style="margin-left: -115px;"
					:http-request="uploadSituation" multiple drag :show-file-list=false :auto-upload="true" :before-upload="beforeUploadSituation"
					accept="image/jpeg,image/png,image/jpg">
					<i class="el-icon-upload"></i>
					<div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
				</el-upload>
			</el-col>
		</el-row>
		<el-row style="margin-top:10px">
			<el-col :span="24">
				<el-table v-if="dataForm.photoRecords != undefined && dataForm.photoRecords.length > 0" border
					:data="dataForm.photoRecords" style="width: 100%;">
					<el-table-column type="index" label="No." width="60" align="center">
					</el-table-column>
					<el-table-column label="图片" width="180" align="center">
						<template slot-scope="scope">
							<el-image style="height: 100px" :src="scope.row.compressedPathUri" fit='contain'></el-image>
						</template>
					</el-table-column>
					<el-table-column label="描述" width="500px" align="center">
						<template slot-scope="scope">
							<el-input type="textarea" rows="2" v-model="dataForm.photoRecords[scope.$index].photoContent"
								placeholder="请填写"></el-input>
						</template>
					</el-table-column>
					<el-table-column label=" " width="120" align="center">
						<template slot-scope="scope">
							<el-button type="text" @click="delPhoto(scope.$index)">删除</el-button>
						</template>
					</el-table-column>
				</el-table>
			</el-col>
		</el-row>
		<el-row class="formBtnGroup">
			<el-col :span="24">
				<el-button class="btn" type="primary" size="small" @click="dataSubmit()">保存</el-button>
			</el-col>
		</el-row>
	</el-dialog>
</template>

<script>
import $common from "@/utils/common.js"
import { initDialogDrag } from '@/utils/dialogDrag.js'
export default {
	name: "add-or-update-meeting",
	data() {
		return {
			subVisible: true,
			dataForm: {
				recNo: '',
				dataKind: '',
				weeklyRecNo: '',
				dataType: '',
				sourceId: '',
				sourceType: 0,
				sort: 0,
				descContent: '',
				photoRecords: [],
				updUserName: '',
				subjectNo: '',
				major: ''
			},
			recNo: '',
			title: '',
			dataType: '',
			subjectNo: '',
			major: ''
		};
	},
	methods: {
		init(weeklyRecNo, recNo, sort, dataType, subjectNo, major) {
			// 标题
			if (dataType === '010100') {
				if (!recNo) {
					this.title = '新增重要事项描述'
				} else {
					this.title = '修改重要事项描述'
				}
			} else if (dataType === '020300') {
				if (!recNo) {
					this.title = '新增详细进度情况'
				} else {
					this.title = '修改详细进度情况'
				}
			} else if (dataType === '030101') {
				if (!recNo) {
					this.title = '新增总体描述'
				} else {
					this.title = '修改总体描述'
				}
			} else if (dataType === '030102') {
				if (!recNo) {
					this.title = '新增主要质量问题跟踪处理情况'
				} else {
					this.title = '修改主要质量问题跟踪处理情况'
				}
			} else if (dataType === '030201') {
				if (!recNo) {
					this.title = '新增总体描述'
				} else {
					this.title = '新增总体描述'
				}
			} else if (dataType === '030202') {
				if (!recNo) {
					this.title = '新增突出问题跟踪处理情况'
				} else {
					this.title = '新增突出问题跟踪处理情况'
				}
			} else if (dataType === '040000') {
				if (!recNo) {
					this.title = '新增文件审查情况'
				} else {
					this.title = '修改文件审查情况'
				}
			} else if (dataType === '050000') {
				if (!recNo) {
					this.title = '新增设计修改及审图意见落实情况'
				} else {
					this.title = '修改设计修改及审图意见落实情况'
				}
			} else if (dataType === '060000') {
				if (!recNo) {
					this.title = '新增HSE情况'
				} else {
					this.title = '修改HSE情况'
				}
			} else if (dataType === '070000') {
				if (!recNo) {
					this.title = '新增会议情况'
				} else {
					this.title = '修改会议情况'
				}
			} else if (dataType === '080000') {
				if (!recNo) {
					this.title = '新增其他需要说明的问题'
				} else {
					this.title = '修改其他需要说明的问题'
				}
			}
			this.dataType = dataType
			this.subjectNo = subjectNo
			this.major = major

			this.dataForm = {
				recNo: '',
				workNo: $common.getItem("workNo"),
				weeklyRecNo: weeklyRecNo,
				dataType: this.dataType,
				subjectNo: this.subjectNo,
				major: this.major,
				sourceId: '',
				sourceType: '',
				dataKind: '1',
				sort: sort,
				descContent: '',
				photoRecords: [],
				updUserName: $common.getItem("userName"),
			}
			this.dataForm.recNo = recNo;
			this.$nextTick(() => {
				this.subVisible = true;
				initDialogDrag(this.$refs.dialog.$el);
			})
			if (recNo) {
				this.getWeeklyMeetingDetail();
			}

		},
		getWeeklyMeetingDetail() {
			this.$http({
				url: this.$store.state.httpUrl + "/business/weeklyreportdescinfo/getWeeklyDescInfo/" + this.dataForm.recNo,
				method: 'get',
				params: this.$http.adornParams({})
			}).then(({ data }) => {
				if (data && data.resultCode === 200) {
					this.dataForm = data.body
				}
			})

		},
		beforeUploadSituation(file) {
			const isValidType = file.type === 'image/jpeg' ||
				file.type === 'image/png' ||
				file.type === 'image/jpg'

			if (!isValidType) {
				this.$message.error('只能上传 JPG/PNG 格式的图片！')
				return false
			}
			return true
		},
		uploadSituation(param) {
			const formData = new FormData();
			formData.append('file', param.file);
			this.$refs.uploadSituation.clearFiles();
			this.$http.post(
				this.$store.state.httpUrl + "/file/upload/" + $common.getItem("workNo") + "/95/0",
				formData,
				{
					headers: { 'Content-Type': 'multipart/form-data' }
				},
			).then(res => {
				res = res.data
				if (res.resultCode === 200) {
					this.dataForm.photoRecords.push({
						photoFilePath: res.body.fileSavePath,
						photoFilePathUrl: res.body.fileUri,
						compressedPath: res.body.compressedPath,
						compressedPathUri: res.body.fileUri,
						photoContent: this.extractFileName(res.body.fileName),
						workNo: $common.getItem("workNo"),
						recNo: '',
					});
				} else {
					this.$message.info('文件上传失败')
				}
			})
		},
		extractFileName(fileName) {
			let index = fileName.lastIndexOf(".");
			return fileName.substr(0, index)
		},
		delPhoto(index) {
			this.dataForm.photoRecords.splice(index, 1);
		},
		dataSubmit() {
			let _url = "/business/weeklyreportdescinfo/save";
			if (this.dataForm.recNo && this.dataForm.recNo != 0) {
				_url = "/business/weeklyreportdescinfo/update";
			}
			this.$http({
				url: this.$store.state.httpUrl + _url,
				method: "post",
				data: this.$http.adornData(this.dataForm)
			}).then(({ data }) => {
				if (data && data.resultCode === 200) {
					this.$message({
						message: "操作成功",
						type: "success",
						duration: 1500,
						onClose: () => {
							this.subVisible = false;
							this.$emit("refreshDataList");
						}
					});
				}
			});
		},
	}
};
</script>

<style scoped="scoped">
.tiv {
	width: 135px !important;
	background-color: #E1F1FF;
	color: #00428E !important;
	font-weight: bold !important;
	padding: 10px !important;
	text-align: center;
	border: 1px solid #dadada;
}

.upload-demo /deep/ .el-upload-dragger {
	width: 468%;
	height: 100px;
}

.upload-demo /deep/ .el-upload-dragger .el-icon-upload {
	font-size: 40px;
	margin-top: 15px;
	line-height: 26px;
}

.upload-demo /deep/ .el-upload-dragger .el-upload__text {
	line-height: 8px;
}
</style>
